/* eslint-disable */
const getters = {
  getTag(state) {
    return {
      ...state.data,
      photoable_type: 'App\\Tag',
    };
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
